module.exports = __webpack_public_path__ + "img/banner.fe182e8c.png";